import { Sizes } from './types';

export default function findSize(sizes: Sizes, width: number, height: number) {
  if (!sizes || sizes.length === 0) {
    return undefined;
  }

  const found = sizes.find((size) => size.width === width && size.height === height);

  if (found) {
    return found;
  }

  // find closest aspect ratio
  const targetAspectRatio = width / height;
  let nearest = sizes[0];
  let smallestDifference = Math.abs(nearest.width / nearest.height - targetAspectRatio);

  for (const size of sizes) {
    const difference = Math.abs(size.width / size.height - targetAspectRatio);
    if (difference < smallestDifference) {
      nearest = size;
      smallestDifference = difference;
    }
  }

  return nearest;
}
